import budgetApis from "../../../api/master/budget";
import Swal from "sweetalert2";

interface SubmitBudgetParams {
  formData: any;
  status: string;
  navigate: (path: string) => void;
}

export const submitBudgetData = async ({
  formData,
  status,
  navigate,
}: SubmitBudgetParams): Promise<void> => {
  console.log("data", formData);
  let parsedData: any;
  if (formData.budgetHeader?.approvalsData) {
    parsedData = JSON.parse(formData.budgetHeader?.approvalsData);
  }
  const approvalDataArray = parsedData;
  const formattedApprovalData = approvalDataArray?.map((item: any) => ({
    roleId: item.roleId,
    level: item.level,
    userId: item.userId,
  }));

  const isStrictApproval = formData.budgetHeader?.isStrictApproval || false;

  // Determine if auto-generated based on numberingMode or if value is empty
  const isAutoGenerated = formData.budgetHeader?.numberingMode === "auto";

  if (isAutoGenerated) {
    delete formData.budgetHeader.budgetId;
  }

  const submissionData = {
    header: {
      orgId: 1,
      status: status,
      ...(!isAutoGenerated && formData.budgetHeader?.budgetId
        ? { budgetId: formData.budgetHeader.budgetId }
        : {}),
      budgetName: formData.budgetHeader?.budgetName || "",
      startDate: formData.budgetHeader?.startDate || "",
      endDate: formData.budgetHeader?.endDate || "",
      description: formData.budgetHeader?.description || "",
      budgetFor: formData.budgetHeader?.budgetFor || "",
      site: parseInt(formData.budgetHeader?.site) || "",
      costCenter:
        formData.budgetHeader?.costCenter !== undefined
          ? parseInt(formData.budgetHeader?.costCenter)
          : null,
      lob: formData.budgetHeader?.lob || "",
      docRequired: "Y",
      approvalRequired: formData.budgetHeader?.approvalRequired || "",
      instructions: formData?.instructions || "",
      terms: formData?.termsAndConditions || "",
      isStrictApproval: Boolean(isStrictApproval),
    },
    lines:
      formData.materialsData?.map((material: any, index: number) => ({
        budgetLineName: material.budgetLineName || "",
        budgetFor: material.budgetFor || "",
        budgetValue: parseInt(material.budgetValue?.toString()?.replace(/,/g, "") || "0") || 0,
        startDate: material.startDate || "",
        endDate: material.endDate || "",
        bom: material.bom || "",
        allocation: material.allocation || null,
        lineDescription: material.lineDescription || "",
        currencyCode: "INR",
        budgetCategoryId: material.budgetCategoryId
          ? parseInt(material.budgetCategoryId)
          : null,
        customBudgetCategory: material.customBudgetCategory || null,
        department: material.department ? parseInt(material.department) : null,
        contractorId: material.contractorId ? parseInt(material.contractorId) : null,
        bomLines: material.bomLines?.map((bomLine: any, index: number) => {
          const line: any = {
            boqContractorMaterialId: bomLine.boqContractorMaterialId || null,
            categoryId: Number(bomLine.categoryId) || "",
            categoryName: bomLine.categoryName || "",
            materialId: bomLine.materialId || "",
            materialName: bomLine.materialName || "",
            quantity: Number(bomLine.quantity) || "",
            allocated: Number(bomLine.allocated?.toString()?.replace(/,/g, "") || "0") || 0,
            budgetAllocatedQty: Number(bomLine.budgetAllocatedQty?.toString()?.replace(/,/g, "") || "0") || 0,
          };
          if (bomLine.uomId) {
            line.uomId = Number(bomLine.uomId);
            line.uomName = bomLine.uomName || "";
          }
          return line;
        }),
      })) || [],
    approvals: formattedApprovalData || [],
  };

  console.log(JSON.stringify(submissionData));

  // Create FormData object
  const formDataToSend = new FormData();
  formDataToSend.append("header", JSON.stringify(submissionData.header));
  formDataToSend.append("lines", JSON.stringify(submissionData.lines));
  formDataToSend.append(
    "approvals",
    JSON.stringify(submissionData.approvals)
  );

  let _filesData: any = [];

  formData.docKeys?.fileList?.forEach((attachment: any, index: number) => {
    if (!attachment) {
      return;
    }
    const file = attachment?.originFileObj;
    formDataToSend.append(`files`, file);
    _filesData.push({
      fileIndex: index,
      module: "Budget",
      moduleFileType: "Special Instructions",
      level: "HEADER_LEVEL",
    });
  });

  if (formData?.instructions) {
    _filesData.push({
      fileIndex: _filesData.length + 0,
      module: "Budget",
      moduleFileType: "instructions",
      level: "HEADER_LEVEL",
    });
    console.log("090999429", JSON.stringify(formData));
  }

  if (formData?.termsAndConditions) {
    _filesData.push({
      fileIndex: _filesData.length + 0,
      module: "Budget",
      moduleFileType: "termsAndConditions",
      level: "HEADER_LEVEL",
    });
    console.log("090999429", JSON.stringify(formData));
  }

  formDataToSend.append("docKeys", JSON.stringify(_filesData));

  if (formData?.instructions) {
    const instructionsFile = new Blob([formData?.instructions], {
      type: "text/html",
    });
    formDataToSend.append(
      `files`,
      new File([instructionsFile], "instructions.html", {
        type: "text/html",
      })
    );
  }

  if (formData?.termsAndConditions) {
    const termsAndConditionsFile = new Blob([formData?.termsAndConditions], {
      type: "text/html",
    });
    formDataToSend.append(
      `files`,
      new File([termsAndConditionsFile], "termsAndConditions.html", {
        type: "text/html",
      })
    );
  }

  // Call API
  try {
    const dataAPI: any = await budgetApis.budgetCreationMethod(formDataToSend);
    console.log(dataAPI);
    const { status: responseStatus, message, response } = dataAPI;
    if (responseStatus) {
      if (status === "DRAFT") {
        Swal.fire("Saved as Draft!", response?.budgetId, "success");
      } else {
        Swal.fire("Created!", response?.budgetId, "success");
      }
      navigate(`/view-budget`);
    } else {
      Swal.fire("Failed!", message, "error");
    }
  } catch (error) {
    Swal.fire("Failed!", "Something went wrong", "error");
    throw error;
  }
};
